import React from "react";

import {
  Outlet,
} from "react-router-dom";

import {
  Container,
} from "react-bootstrap";

import Header from "./Header";
import Footer from "./Footer";


function ThemeLayout() {

  return (

    <div className="theme3-app">

      <Header />

      <main>

        <Container
          fluid
          className="p-0"
        >

          <Outlet />

        </Container>

      </main>

      <Footer />

    </div>

  );

}


export default ThemeLayout;